(function () {
  var cardSelector = ".m-product-card--mobile-image-change";
  var changedClass = "m-product-card--mobile-image-changed";
  var visibilityThreshold = 0.45;
  var mobileQuery = window.matchMedia("(max-width: 1023px)");
  var observer = null;
  var mutationObserver = null;
  var resizeTimer = null;
  var activeCard = null;
  var cards = new Map();

  function clearCardTimer(card) {
    var state = cards.get(card);

    if (state && state.timer) {
      clearTimeout(state.timer);
      state.timer = null;
    }
  }

  function pauseMedia(card) {
    card.querySelectorAll("video").forEach(function (video) {
      video.pause();
      video.removeAttribute("autoplay");

      try {
        video.currentTime = 0;
      } catch (error) {
        // Some externally-managed videos do not allow seeking until metadata is ready.
      }
    });
  }

  function playActiveMedia(card) {
    card.querySelectorAll(".m-product-card__hover-image video").forEach(function (video) {
      var playPromise = video.play();

      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    });
  }

  function resetCard(card) {
    var state = cards.get(card);
    if (!state) return;

    clearCardTimer(card);
    card.classList.remove(changedClass);
    state.changed = false;
    pauseMedia(card);

    if (activeCard === card) activeCard = null;
  }

  function getCardVisibilityRatio(card) {
    var rect = card.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    var visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);

    if (rect.width <= 0 || rect.height <= 0 || visibleHeight <= 0 || visibleWidth <= 0) return 0;

    return (visibleHeight * visibleWidth) / (rect.width * rect.height);
  }

  function isCardVisible(card) {
    return getCardVisibilityRatio(card) >= visibilityThreshold;
  }

  function isMostVisibleCard(card) {
    var cardRatio = getCardVisibilityRatio(card);
    var bestCard = card;
    var bestRatio = cardRatio;

    cards.forEach(function (state, visibleCard) {
      var visibleRatio = getCardVisibilityRatio(visibleCard);

      if (visibleRatio > bestRatio) {
        bestCard = visibleCard;
        bestRatio = visibleRatio;
      }
    });

    return bestCard === card && cardRatio >= visibilityThreshold;
  }

  function activateCard(card) {
    var state = cards.get(card);
    if (!state || state.changed || !state.visible || !isCardVisible(card) || !isMostVisibleCard(card)) return;

    if (activeCard && activeCard !== card) resetCard(activeCard);

    card.classList.add(changedClass);
    state.changed = true;
    activeCard = card;
    clearCardTimer(card);
    playActiveMedia(card);
  }

  function scheduleActivation(card) {
    var state = cards.get(card);
    var delay = parseFloat(card.dataset.mobileImageChangeDelay || "1");

    if (!state) return;

    clearCardTimer(card);

    if (Number.isNaN(delay) || delay < 0) delay = 1;

    if (delay === 0) {
      activateCard(card);
    } else {
      state.timer = setTimeout(function () {
        activateCard(card);
      }, delay * 1000);
    }
  }

  function handleEntries(entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      var state = cards.get(card);
      if (!state) return;

      state.visible = entry.isIntersecting && entry.intersectionRatio >= visibilityThreshold;

      if (!state.visible) {
        resetCard(card);
        return;
      }

      if (state.changed && !isMostVisibleCard(card)) resetCard(card);
      if (!state.changed) scheduleActivation(card);
    });
  }

  function hasImages(card) {
    return card.querySelector(".m-product-card__main-image") && card.querySelector(".m-product-card__hover-image");
  }

  function cleanupCard(card) {
    var state = cards.get(card);
    if (!state) return;

    resetCard(card);

    if (observer) observer.unobserve(card);
    if (state.onPointerEnter) card.removeEventListener("pointerenter", state.onPointerEnter);
    if (state.onPointerLeave) card.removeEventListener("pointerleave", state.onPointerLeave);
    if (state.onFocusOut) card.removeEventListener("focusout", state.onFocusOut);

    cards.delete(card);
  }

  function cleanupCards(context) {
    cards.forEach(function (state, card) {
      if ((context || document).contains(card)) cleanupCard(card);
    });
  }

  function pruneCards() {
    cards.forEach(function (state, card) {
      if (!document.documentElement.contains(card)) cleanupCard(card);
    });
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      cards.forEach(function (state, card) {
        if (!isCardVisible(card)) {
          state.visible = false;
          resetCard(card);
        }
      });
    }, 150);
  }

  function setupCard(card) {
    if (cards.has(card) || !hasImages(card)) return;

    var state = {
      timer: null,
      changed: false,
      visible: false,
      onPointerEnter: function () {
        state.visible = isCardVisible(card);
        if (state.visible && !state.changed) scheduleActivation(card);
      },
      onPointerLeave: function () {
        resetCard(card);
      },
      onFocusOut: function () {
        resetCard(card);
      }
    };

    cards.set(card, state);
    card.classList.remove(changedClass);
    pauseMedia(card);
    card.addEventListener("pointerenter", state.onPointerEnter);
    card.addEventListener("pointerleave", state.onPointerLeave);
    card.addEventListener("focusout", state.onFocusOut);
    observer.observe(card);
  }

  function resetRemovedCards(mutation) {
    mutation.removedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;

      if (node.matches && node.matches(cardSelector)) {
        cleanupCard(node);
        return;
      }

      if (node.querySelectorAll) node.querySelectorAll(cardSelector).forEach(cleanupCard);
    });
  }

  function observeCards(context) {
    if (!observer || !mobileQuery.matches) return;

    pruneCards();

    (context || document).querySelectorAll(cardSelector).forEach(setupCard);
  }

  function enable() {
    if (!("IntersectionObserver" in window) || !mobileQuery.matches) return;

    if (!observer) {
      observer = new IntersectionObserver(handleEntries, {
        threshold: [0, visibilityThreshold, 0.6, 0.75, 0.9, 1]
      });
    }

    observeCards(document);
    window.addEventListener("resize", handleResize, { passive: true });

    if (!mutationObserver) {
      mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          resetRemovedCards(mutation);

          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(cardSelector)) observeCards(node.parentNode || document);
            if (node.querySelectorAll) observeCards(node);
          });
        });
      });
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function disable() {
    window.removeEventListener("resize", handleResize);
    clearTimeout(resizeTimer);
    resizeTimer = null;

    if (observer) observer.disconnect();
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }

    cards.forEach(function (state, card) {
      clearCardTimer(card);
      pauseMedia(card);
      card.classList.remove(changedClass);
      if (state.onPointerEnter) card.removeEventListener("pointerenter", state.onPointerEnter);
      if (state.onPointerLeave) card.removeEventListener("pointerleave", state.onPointerLeave);
      if (state.onFocusOut) card.removeEventListener("focusout", state.onFocusOut);
    });

    cards.clear();
    observer = null;
    activeCard = null;
  }

  function handleMediaChange(event) {
    if (event.matches) {
      enable();
    } else {
      disable();
    }
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", handleMediaChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleMediaChange);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (mobileQuery.matches) {
      enable();
      observeCards(event.target);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    cleanupCards(event.target);
  });

  document.addEventListener("page:loaded", function () {
    if (mobileQuery.matches) {
      enable();
      observeCards(document);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enable);
  } else {
    enable();
  }
})();
